<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h5>Asistente para el registro de usuarios administrativos y de soporte</h5>
    <div style="display: flex; justify-content: space-between; background-color: #f0f0f0; padding: 10px; border-radius: 5px;">
      <h4>3. Resumen del Usuario Creado</h4>
<!--
      <h4 style="margin: 0;">
        <span class="btn btn-secondary">1</span>
        <span class="btn btn-secondary">2</span>
        <span class="btn btn-success"><b>3</b></span>
      </h4>
-->
    </div>
    <hr>
    <p>El registro del nuevo usuario ha sido completado exitosamente. A continuación, puedes revisar los detalles del usuario añadido:</p>
    <!-- Modal -->
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header-custom">
          <h5 class="modal-title" id="exampleModalLabel">
            <i class="fa fa-user-plus"></i> {{ titulo }}
          </h5>
        </div>
        <form>
          <div class="modal-body">

            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label class="form-label custom-bold-label">Nombre</label>
                </div>
                <div class="col-10">
                  <span>{{ datoUsuario.nombre }}</span>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label class="form-label custom-bold-label">Perfil</label>
                </div>
                <div class="col-10">
                  <span>{{ datoUsuario.perfilNombre }}</span>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer custom-footer">
          <button type="submit" class="btn btn-info" @click.prevent="citas" title="Finalizar">
            <i class="material-icons" style="font-size:32px;color:green; cursor: pointer;">done</i>Volver a la Lista de Usuarios
          </button>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
export default {
  components: {
    Layout, Footer
  },
  data() {
    return {
      datoUsuario: {},
      nombreBusqueda: '',
      titulo: '',
      modalWindow: true,
      p_idPersona: 0,
      p_idAuto: 0,
      p_idCita: 0,
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted() {
//    alert('empresa: '+window.sessionStorage.getItem("idEmpresa")+'; suscripcion: '+window.sessionStorage.getItem("idSuscripcion"));
      this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
//    this.p_idPersona = this.$route.params.p_idpersona
    this.p_idUsuario = this.$route.params.p_idmedico;
    this.getPersona();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    getPersona() {
      api.get('/vwusuarios/' + this.p_idUsuario).then(response => {
        this.datoUsuario = response.data;
      });
    },
    citas() {
      this.$router.push('/medico')
    }
  },
}
</script>
<style src="@/assets/css/wizardResumen.css" scoped></style>